import { gql } from "./api";

interface GetOrganizationInput {
    uuid: String;
    token: String;
    organization_id: number | string | undefined;
}

interface CreateOrganizationInput {
    uuid: string;
    token: String;
    user_uuid: String;
    name: String;
    shortname: String;
    website: String;
    country: String;
    city: String;
    address: String;
    postal_code: String;
}

interface EditOrganizationInput {
    uuid: string;
    token: String;
    organization_id: Number | undefined | string;
    name: String;
    shortname: String;
    website: String;
    country: String;
    city: String;
    address: String;
    postal_code: String;
}

export const EditOrganization = async({
    uuid, token, organization_id, name, shortname, website, country, city, address, postal_code
}: EditOrganizationInput) => {

    const response = await gql({
        query: 
            `mutation EditOrganization {
                editOrganization(
                    editOrganizationInput: {
                        uuid: "${uuid}"
                        token: "${token}"
                        organization_id: ${organization_id}
                        name: "${name}"
                        shortname: "${shortname}"
                        website: "${website}"
                        country: "${country}"
                        city: "${city}"
                        address: "${address}"
                        postal_code: "${postal_code}"
                    }
                ) {
                    name
                    shortname
                    website
                    country
                    city
                    address
                    postal_code
                    photo
                    organizations_count
                    users_count
                    organizations {
                        id
                        name
                        shortname
                        uuid
                        token
                        website
                        country
                        city
                        address
                        postal_code
                        photo
                    }
                }
            }
            `,
            returnFunc: 'editOrganization'
    })

    return response

}

export const CreateOrganization = async({
    uuid, token, user_uuid, name, shortname, website, country, city, address, postal_code
}: CreateOrganizationInput) => {

    const response = await gql({
        query: 
            `mutation CreateOrganiation {
                    createOrganization (
                        organizationInput: {
                            uuid: "${uuid}"
                            token: "${token}"
                            user_uuid: "${user_uuid}"
                            name: "${name}"
                            shortname: "${shortname}"
                            website: "${website}"
                            country: "${country}"
                            city: "${city}"
                            address: "${address}"
                            postal_code: "${postal_code}"
                        }
                    ) {
                        name
                        shortname
                        website
                        country
                        city
                        address
                        postal_code
                        id
                    }
        }`,
        returnFunc: 'createOrganization'
    })

    return response

}

export const GetOrganization = async ({
    uuid, token, organization_id
}: GetOrganizationInput) => {

    const response = await gql({
        query: `
            mutation GetOrganization {
                getOrganization(
                    getOrganizationInput: {
                        uuid: "${uuid}"
                        token: "${token}"
                        organization_id: ${organization_id}
                    }
                ) {
                    organization {
                        name
                        shortname
                        uuid
                        token
                        website
                        country
                        city
                        address
                        postal_code
                        photo
                    }
                }
            }`, 
        returnFunc: 'getOrganization'
    })

    return response.organization;

}


